import Instance from '../../../utils/Axios';

// New Actions for the app

const GetTiposPeriodos = () => async (dispatch) => {
  await Instance()
    .get(`/tipoperiodos`)
    .then(({ data }) => {
      dispatch({ type: 'GET_TIPOPERIODOS', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetTiposPeriodos;
